module.exports = __webpack_public_path__ + "media/images/territory_landing_pages/hero_banner/component/beauty-desktop@2x-b82309aef44793ee6901b183dcc1c624.jpg";